var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h1',[_vm._v("Profile")]),_c('img',{staticClass:"rounded-lg",attrs:{"src":_vm.$store.state.user.profileImg}})])
}
var staticRenderFns = []

export { render, staticRenderFns }